import { render, staticRenderFns } from "./cPartsWithDocuments.vue?vue&type=template&id=6ace2e76&scoped=true"
import script from "./cPartsWithDocuments.vue?vue&type=script&lang=js"
export * from "./cPartsWithDocuments.vue?vue&type=script&lang=js"
import style0 from "./cPartsWithDocuments.vue?vue&type=style&index=0&id=6ace2e76&prod&scoped=true&lang=css"
import style1 from "./cPartsWithDocuments.vue?vue&type=style&index=1&id=6ace2e76&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ace2e76",
  null
  
)

export default component.exports